import { useCallback, useEffect, useMemo, useState } from 'react'
import { useAppSelector } from '../redux/hook';
import { HoldingOwner } from '../models/polymer/HoldingOwner.model';
import { HoldingOccupier } from '../models/polymer/HoldingOccupier.model';

export default function useRetrieveMyInfo(item: HoldingOwner | HoldingOccupier, allowToggle:boolean, retrieveCallBack?:()=>void, removeCallBack?:()=>void) {

  const retrieveMyInfoByNRIC = useAppSelector(state => state.auth.AuthenticationSlice.retrieveFromMyInfo);
  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);

  const [ isRetrieve, setRetrieve ] = useState<boolean>(false);
  const [ isMyInfoLoading, setMyInfoLoading ] = useState<boolean>(false);
  const [ init, setInit ] = useState<boolean>(true);

  const [ isEditing, setIsEditing ] = useState<boolean>(false);

  useEffect(()=>{
    setIsEditing(allowToggle);
  },[allowToggle])

  const toShowMyInfo = useMemo(() => {
    if (item.type === "existing" && loginUser.uinfin === item.original_uinfin) {
      if (item.is_proposed) {
        if ((isEditing)) {
          return true;
        }
        else {
          return false;
        }
      }
      else {
        if (isRetrieve) {
          return true
        }
      }
      return true;
    }
    return false;

  }, [isEditing, item.type, item.original_uinfin, item.is_proposed, loginUser.uinfin, isRetrieve])


  useEffect(() => {
    let timeout_id:number;
    timeout_id = window.setTimeout(()=>{
      if(retrieveMyInfoByNRIC){
        if(init && retrieveCallBack && item.type === "existing" && loginUser.uinfin === item.original_uinfin){
          setMyInfoLoading(true);
          retrieveCallBack();
          setRetrieve(true);
          setInit(false);
          setTimeout(()=>{
            setMyInfoLoading(false);
          },1000);
        }
      }
    },500);

    return () =>{
      clearTimeout(timeout_id);
    }
  }, []);

  const toggleRetrieveMyInfo = useCallback(()=>{
    setMyInfoLoading(true);
    let timeout_id:number;

    timeout_id = window.setTimeout(()=>{
      if(!isRetrieve){
        if(retrieveCallBack){
          retrieveCallBack();
          setRetrieve(true);
        }
      }else{
        if(removeCallBack){
          removeCallBack();
          setRetrieve(false);
        }
      }
      setTimeout(()=>{
        setMyInfoLoading(false);
      },1000)
    },200);

    return () =>{
      clearTimeout(timeout_id);
    }
  },[isRetrieve, removeCallBack, retrieveCallBack]);
  
  
  const myInfoLoadingValue = useCallback((value:boolean)=>{
    setMyInfoLoading(value);
  },[])

  return { isRetrieve, isMyInfoLoading, toShowMyInfo, toggleRetrieveMyInfo, myInfoLoadingValue, setRetrieve }
}
